define('views/parts/fetch-button',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
    // templates
    'text!templates/parts/fetch-button.html',

], function(
    // Libs
    _, Backbone, Mustache, U,
    // templates
    TFetchButton
) {

    /**
     * Used for load more type buttons which must wait for fetch or long
     * processing.
     *
     * @param {String} label of the button.
     * @param {String} class to add to the button's classes.
     * @param {String} icon if different from default.
     * @param {Function} callback a function which takes the event and a callback as arguments.
     * @param {Object} context the 'this' value of the callback.
     */
    var VFetchButton = Backbone.View.extend({

        template: TFetchButton,
        events: {
            "click .fetch-button": "onClick",
        },

        // abstracting selectors out of the view logic
        regions: {
            button: ".fetch-button",
            icon: ".fetch-button span",
        },

        initialize: function(options) {
            this.options = _.extend({
                async: true,
                icon: "sl-icon-arrow-down",
                label: 'Show more messages',
                loading: "fa fa-refresh fa-spin fa-fw",
            }, options);

            this.disabled = false;

            // prepare the reseting callback
            this.finished = this.finished.bind(this);

        },

        render: function() {
            var html = Mustache.render(this.template, Mustache.getContext(this.options));
            this.$el.empty().append(html);

            this.generateZones();

            return this;
        },

        toggle: function(val) {
            if (!_.isUndefined(val)) val = !val;
            this.$el.toggleClass('hidden', val);
        },

        loading: function(val) {
            var options = this.options,
                icon = options.icon,
                loading = options.loading,
                $elem = this.zone.$icon;
            $elem.removeClass(val ? icon : loading)
                .addClass(val ? loading : icon);
        },

        disableButton: function(val) {
            if (this.zone && this.zone.$button) {
                this.disabled = _.isUndefined(val) ? !this.disabled : Boolean(val);
                this.zone.$button.toggleDisabled(this.disabled);
            }
        },

        isEnabled: function() {
            return !this.disabled;
        },

        // Is being bound to 'this' on init.
        finished: function() {
            this.loading(false);
            this.disableButton(false);
        },

        ////////////
        // events //
        ////////////

        onClick: function(e) {
            var options = this.options,
                params = [e, this.finished];
            // disable the button and show a loading icon.
            this.disableButton(true);

            if (options.async !== false) {
                this.loading(true);
            }

            _.callback(options.context, options.callback, params);

            // trigger an event for objects other than the parent.
            this.trigger.apply(this, ["fetchButton:click"].concat(params));
        },

    });

    return VFetchButton;
});

